
import { useEffect, useState } from "react";
import { Button, Grid } from "@mui/material";
import { useCalcularPrecios, separadorMillares } from "../../../hooks";
import { TextFormField, ViewPreciosPorRol } from "../../components";
import { buscarProducto } from "../../../helpers/FormulariosCarrito";

import Swal from "sweetalert2";



export const FormularioSoloCantidad = ({ formCarrito, setFormCarrito, funcionAgregar, poducto, 
                                        carrito, titulo='Agregar Producto', medida=6 }) => {


    const { calcularPrecioSoloCantidad } = useCalcularPrecios();
    const [ precioReal, setPrecioReal ] = useState(0);



    useEffect( () => {
        if( poducto ) {
            const { cliente, distri, empresa, publicista, precioReal } = calcularPrecioSoloCantidad(formCarrito.cantidad, poducto);
            setPrecioReal( precioReal - cliente );
            setFormCarrito({
                ...formCarrito,
                totalCliente: cliente,
                totalDistri: distri,
                totalEmpresa: empresa,
                totalPublicista: publicista,
            });
        }
    }, [poducto, formCarrito.cantidad]);



    const handleInputChange = ({ target }) => {
        setFormCarrito({
            ...formCarrito,
            [target.name]: target.value
        });
    }


    
    const handleAgregarAlCarro = (e) => {
        e.preventDefault();
        if( formCarrito.cantidad <= 0 ) { return Swal.fire('Error', 'Debes poner una cantidad', 'error') }
        const itemID = buscarProducto(carrito, formCarrito.producto);
        funcionAgregar(itemID)
    }



    return (

        <form onSubmit={ handleAgregarAlCarro } style={{ width:'100%' }}>
            <Grid container sx={{width:'100%', mt:2, display:'flex', justifyContent:'space-between'}} >
                <Grid item xs={12} sm={medida}>
                    <TextFormField
                        size="small"
                        label='Cantidad'
                        type='number'
                        placeholder="Cantidad"
                        name="cantidad"
                        min="1"
                        max="100"
                        value={formCarrito.cantidad}
                        onChange={ handleInputChange } 
                        fullWidth
                    />
                </Grid>
            </Grid>

            {/* Mostrar Precio Segun Rol */}
            <ViewPreciosPorRol formCarrito={formCarrito} />

            <Grid container sx={{ mt:1 }} spacing={2}>
                <Grid item xs={12} sm={(precioReal <= 0) ? 12 : medida}>
                    <Button type="submit" color='primary' variant="contained" fullWidth>{ titulo }</Button>
                </Grid>

                {(precioReal > 0) && (
                <Grid item xs={12} sm={medida}>
                    <Button color='secondary' variant="contained" fullWidth>
                        Ahorra { `$${ separadorMillares( precioReal ) }`}
                    </Button>
                </Grid>
                )}
            </Grid>
        </form> 
    )

}
